export default __webpack_public_path__ + "86409083787e3540ba18990169a97d27.svg";